import React from "react";
import LocalizationManagerWrapper from "../LocalizationManager";
const Skeleton = /* @__PURE__ */ React.createElement(React.Fragment, null);
const withLocalization = (Component, resourcesId, resources, loadingElement = Skeleton) => {
  const ComponentWithLocalization = ({ locale = "en-gb", ...props }) => /* @__PURE__ */ React.createElement(LocalizationManagerWrapper, {
    id: `@trainline-shareable/${resourcesId}`,
    locale: locale.toLowerCase(),
    resources,
    loadingElement
  }, /* @__PURE__ */ React.createElement(Component, {
    ...props
  }));
  ComponentWithLocalization.displayName = `withLocalization(${Component.displayName || Component.name})`;
  return ComponentWithLocalization;
};
var withLocalization_default = withLocalization;
export {
  withLocalization_default as default
};
